/**
 * @file Signup form component
 * @author Denny K. Schuldt
 * @copyright Copyright 2017, Datilmedia S.A.
 */

import React from 'react';
import ReactDOM from 'react-dom';


const Form = (props) => {

  const state = props.state;

  const handleUsernameChange = (e) => {
    let url = props.isUsernameAvailableUrl.replace("USERNAME", e.target.value);
    props.onUsernameChange(e.target.value)
    props.onUsernameValidate(url);
  }
  const handleEmailChange = (e) => {
    let url = props.isEmailAvailableUrl.replace("EMAIL", e.target.value);
    props.onEmailChange(e.target.value)
    props.onEmailValidate(url);
  }
  const handlePasswordChange = (e) => props.onPasswordChange(e.target.value)

  const handleUsernameValidation = (e) => {
    let url = props.isUsernameAvailableUrl.replace("USERNAME", e.target.value);
    props.onUsernameValidate(url);
  }
  const handleEmailValidation = (e) => {
    let url = props.isEmailAvailableUrl.replace("EMAIL", e.target.value);
    props.onEmailValidate(url);
  }
  const handlePasswordValidation = () => props.onPasswordValidate()
  const handleFormSubmit = (e) => {
    e.preventDefault();
    e.persist();
    if (!state.getIn(['validating', 'username']) && !state.getIn(['validating', 'email'])) {
      return props.onFormSubmit(e)
    }
  }

  return (
    <form className="signup-form" method="POST" action={props.signupUrl} onSubmit={handleFormSubmit}> 
      <header>
        <img src="https://datil-co.s3.amazonaws.com/images/home/home-banner-icon.png" alt="Cuenta Dátil"/>
        <h3>Crea tu cuenta</h3>
      </header>

      <div className={ state.get("error").length ? "signup-error" : "hide" }>
        { state.get('error') }
      </div>

      <div className={ state.getIn(['validations', 'localUsername']).length ||
                        state.getIn(['validations', 'remoteUsername']).length ?
                      "form-group has-error" : "form-group" }>
        <label className="control-label">Elige un nombre de usuario</label>
        <input
          type="text"
          name="username"
          maxLength="30"
          autoCorrect="off"
          autoCapitalize="off"
          placeholder="Ejm: jperez"
      className="form-control"
          value={ state.getIn(['data', 'username']) }
          onChange={ handleUsernameChange }
          onBlur={ handleUsernameValidation }/>
        <span className={ state.getIn(['validating', 'username']) ? "form-control-loading" : "hide" }></span>
        <div className="form-control-error">
          {
            state.getIn(['validations', 'localUsername']) ||
            state.getIn(['validations', 'remoteUsername'])
          }
        </div>
      </div>

      <div className={ state.getIn(['validations', 'localEmail']).length ||
                        state.getIn(['validations', 'remoteEmail']).length ?
                      "form-group has-error" : "form-group" }>
        <label className="control-label">Dirección de correo electrónico</label>
        <input
          type="text"
          name="email"
          placeholder="josesanchez@empresa.com"
          className="form-control"
          value={ state.getIn(['data', 'email']) }
          onChange={ handleEmailChange }
          onBlur={ handleEmailValidation }/>
        <span className={ state.getIn(['validating', 'email']) ? "form-control-loading" : "hide" }></span>
        <div className="form-control-error">
          {
            state.getIn(['validations', 'localEmail']) ||
            state.getIn(['validations', 'remoteEmail'])
          }
        </div>
      </div>

      <div className={ state.getIn(['validations', 'password']).length ?
                      "form-group has-error" : "form-group" }>
        <label className="control-label">Inventa una contraseña</label>
        <input
          type="password"
          name="password"
          placeholder="●●●●●●●●●●"
          minLength="8"
          className="form-control"
          value={ state.getIn(['data', 'password']) }
          onChange={ handlePasswordChange }
          onBlur={ handlePasswordValidation }/>
        <div className="form-control-error">
          { state.getIn(['validations', 'password']) }
        </div>
      </div>

      <div>
        <div>
          <input type="hidden" name="src" value={ state.getIn(['data', 'src']) }/>
          <input type="hidden" name="promo" value={ state.getIn(['data', 'promo']) }/>
          <input type="hidden" name="plan_fee" value={ state.getIn(['data', 'planFee']) }/>
          <input type="hidden" name="plan_code" value={ state.getIn(['data', 'planCode']) }/>
          <input type="hidden" name="origin" value="https://datil.com"/>
          <input type="hidden" name="referral_code" value={ state.getIn(['data', 'referral_code']) }/>
        </div>
      </div>

      <input
        id="signupsubmit"
        type="submit"
        name="signupsubmit"
        value={ state.get('submitting') ? "Creando cuenta..." : "Crear Cuenta" }
        className="btn btn-primary"
        disabled={ state.getIn(['validating', 'username']) || state.getIn(['validating', 'email']) || state.get('submitting')}
         />

      <footer>
        <p>¿Ya tienes una cuenta? <a href="https://app.datil.com"><strong>INICIA SESIÓN</strong></a></p>
      </footer>
    </form>
  )
}

module.exports = Form;
